import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postDriversDHTLimits } from '../../services/DriversService';
import { DHTLimitsResponse, DHTLimits } from '../../types/Drivers';

type Result = UseMutationResult<DHTLimits, Error, DHTLimitsResponse>;

function usePostDHTLimits(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postDriversDHTLimits, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['drivers-dht'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostDHTLimits;
